var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question",
    transform: "translate(-0.275 -0.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7260",
    "data-name": "Rectangle 7260",
    width: 27,
    height: 27,
    transform: "translate(0.275 0.275)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_621",
    "data-name": "Ellipse 621",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(3.275 3.275)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_622",
    "data-name": "Ellipse 622",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(12.275 18.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65207",
    "data-name": "Path 65207",
    d: "M102.983,86.819v-.852A2.983,2.983,0,1,0,100,82.983",
    transform: "translate(-89.346 -71.476)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.f62ba5371be6248f1b68589c1c8d86e1.svg";
export { ForwardRef as ReactComponent };